// eslint-disable-next-line import/prefer-default-export
export const ROUTER_PATHS = {
  HOME: '/',
  LOGIN: '/login',
  SIGN_UP: '/signup',
  EMAIL_ACTIONS: '/actions/email',
  RECOVERY_PASSWORD: '/recovery-password',
  SUCCESS_RECOVERY_PASSWORD: '/recovery-password/success',
  ACCOUNT: '/account',
  PROBLEMS: '/problems',
  PROMISES: '/promises',
  REWARDS: '/rewards',
  TARGETING: '/targeting',
  CONTACTS: '/contacts',
  UNINSTALL_EXTENSION: '/uninstall',
  TARGETING_INFO: '/account/targeting',
  PRIVATE_INFO: '/account/private',
  DIGITAL_FINGERPRINT: '/account/digital-fingerprint',
  SUCCESS_REGISTRATION: '/signup/success',
  REFERRALS: '/referrals',
  OPTIONS: '/options',
};
